export default __webpack_public_path__ + "static/media/p-sm-1.6ddc27f9.png";